export default __webpack_public_path__ + "static/media/poor_active.7fca7f6b.svg";